import { createCachedSelector } from 're-reselect';

import getSecondaryNavParentList from '@/state/selectors/secondary-nav/get-secondary-nav-parent-list';
import { IStore } from '@/state/slices/typings';

const getNextBreadcrumbTitle = createCachedSelector(
	[getSecondaryNavParentList, (_: IStore, index: number) => index],
	(secondaryNavParentList, index) => {
		const nextItem = secondaryNavParentList?.[index + 1];
		if (!nextItem || nextItem.subNavList?.length) return null;

		return nextItem.title;
	},
)((_: IStore, index: number) => String(index));

export default getNextBreadcrumbTitle;
